import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    error: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
// Participant/Misc/Types/Get/{AuthToken}/	
// Participant/Misc/Type/Update/{AuthToken}/{ParticipantPhoneTypeGuid}/{PhoneTypeName}/{PhoneTypeDescription}/	
// Participant/Misc/Type/Delete/{AuthToken}/{ParticipantPhoneTypeGuid}/	
// Participant/Misc/Type/Create/{AuthToken}/{PhoneTypeName}/{PhoneTypeDescription}/	
export const fetchPhoneTypes = createAsyncThunk('phonetype/get', async (incomingVariable, thunkAPI) => {
    console.log('called fetch phonetype')
    try {
        const response = await axios.get(PLATFORM + "Participant/Misc/Types/Get/" + incomingVariable.authToken + "/")
        const data = await response.data.Success ? response.data : []
        //console.log('getting data', data)
        return data
    } catch (err) {
        console.log('error', err)
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const updatePhoneTypes = createAsyncThunk('phonetype/update', async (incomingVariable, thunkAPI) => {
    console.log('called update phonetype')
    try {
        const response = await axios.post(PLATFORM
            + "Participant/Misc/Type/Update/"
            + incomingVariable.authToken + "/"
            + incomingVariable.ParticipantPhoneTypeGuid + "/"
            + incomingVariable.PhoneTypeName + "/"
            + incomingVariable.PhoneTypeDescription + "/"
        )
        const data = await response.data.Success ? response.data : []
        return data
    } catch (err) {
        console.log('error', err)
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const deletePhoneTypes = createAsyncThunk('phonetype/delete', async (incomingVariable, thunkAPI) => {
    console.log('called delete phonetype')
    try {
        const response = await axios.post(PLATFORM
            + "Participant/Misc/Type/Delete/"
            + incomingVariable.authToken + "/"
            + incomingVariable.ParticipantPhoneTypeGuid + "/"
        )
        const data = await response.data.Success ? response.data : []
        return data
    } catch (err) {
        console.log('error', err)
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})
 
export const createPhoneTypes = createAsyncThunk('phonetype/create', async (incomingVariable, thunkAPI) => {
    console.log('called update phonetype')
    try {
        const response = await axios.post(PLATFORM
            + "Participant/Misc/Type/Create/"
            + incomingVariable.authToken + "/"
            + incomingVariable.PhoneTypeName + "/"
            + incomingVariable.PhoneTypeDescription + "/"
        )
        const data = await response.data.Success ? response.data : []
        return data
    } catch (err) {
        console.log('error', err)
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

const phonetypeSlice = createSlice({
    name: 'phonetypes',
    initialState,
    reducers: {        
        phonetypeClear(state, action) {
            state.entities = initialState
            state.status = "idle"
            
        }
    },
    extraReducers(builder) {
        builder
            //
            .addCase(fetchPhoneTypes.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchPhoneTypes.fulfilled, (state, action) => {
                state.status = 'success'
                const loadedData = action.payload.Info
                const data = {}
                for (var i = 0; i < loadedData.length; i++) {
                    data[loadedData[i].ParticipantPhoneTypeGuid] = loadedData[i]
                }
                state.entities = data
            })
            .addCase(fetchPhoneTypes.rejected, (state, action) => {
                state.error = action.error.message
                console.log('failed')
            })
            
            //
            .addCase(updatePhoneTypes.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(updatePhoneTypes.fulfilled, (state, action) => {
                state.status = 'success'
                const loadedData = action.payload.Info
                state.entities[loadedData.ParticipantPhoneTypeGuid] = loadedData
            })
            .addCase(updatePhoneTypes.rejected, (state, action) => {
                state.error = action.error.message
                console.log('failed')
            })
            
            //
            .addCase(deletePhoneTypes.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(deletePhoneTypes.fulfilled, (state, action) => {
                state.status = 'success'
                const loadedData = action.payload.Info
                delete state.entities[loadedData.ParticipantPhoneTypeGuid]
            })
            .addCase(deletePhoneTypes.rejected, (state, action) => {
                state.error = action.error.message
                console.log('failed')
            })


    }
})

export const { phonetypeClear} = phonetypeSlice.actions

export default phonetypeSlice.reducer

const selectPhoneTypeEntities = (state) => state.phonetypes.entities

export const selectPhoneTypes = createSelector(selectPhoneTypeEntities, (entities) =>
    Object.values(entities)
)

export const selectPhoneTypeById = (state, PhoneTypeId) => {
    return selectPhoneTypeEntities(state)[PhoneTypeId]
}

